//#region src/domain/i18n/phone-number-prefix.ts
var PhoneNumberPrefix = /* @__PURE__ */ function(PhoneNumberPrefix) {
	PhoneNumberPrefix["DO"] = "1";
	PhoneNumberPrefix["GT"] = "502";
	PhoneNumberPrefix["HN"] = "504";
	PhoneNumberPrefix["PE"] = "51";
	return PhoneNumberPrefix;
}({});
//#endregion
export { PhoneNumberPrefix };

//# sourceMappingURL=phone-number-prefix.js.map